export const linear = (p, min, max) => (p - min) / (max - min);
export const clamp01 = (p) => Math.max(Math.min(p, 1), 0);
